import $http from '@/api';
import store from '@/store';

export default {
  async fetch(id) {
    return $http.get(`/api/navigation/${id}`);
  },
  async create(params) {
    params.context = store.getters.context;
    return $http.post('/api/navigation', params);
  },
  async delete(id) {
    return $http.delete(`/api/navigation/${id}`);
  },
};
